import React from "react";
import ProjectOverview from "../ProjectOverview/ProjectOverview";

function EditProject({
  account_id,
  account_slug,
  statusLabels,
  salesExecutiveCreatePermission,
  projectOverviewPrivilege,
  requestApprovalPrivilege,
  blueprintCreatePermission,
}) {
  const location = window.location.href;
  var locationArr = location.split("/");
  var id = locationArr[locationArr.length - 2];

  return (
    <ProjectOverview
      project_id={id}
      account_id={account_id}
      account_slug={account_slug}
      statusLabels={statusLabels}
      salesExecutiveCreatePermission={salesExecutiveCreatePermission}
      projectOverviewPrivilege={projectOverviewPrivilege}
      requestApprovalPrivilege={requestApprovalPrivilege}
      blueprintCreatePermission={blueprintCreatePermission}
    />
  );
}

export default EditProject;
